import { render, staticRenderFns } from "./NewsDetailMobile.vue?vue&type=template&id=92ef27c6&scoped=true&"
import script from "./NewsDetailMobile.vue?vue&type=script&lang=js&"
export * from "./NewsDetailMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailMobile.vue?vue&type=style&index=0&id=92ef27c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ef27c6",
  null
  
)

export default component.exports